import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'
import { GROUP, LIST } from '@adalo/constants'
import { withRouter } from 'react-router-dom'

import {
  ADD,
  BRANDING,
  DATA,
  SETTINGS,
  PUBLISH,
  SCREENS,
  ANALYTICS,
  VERSIONS,
} from 'utils/tabs'
import { useFlags } from 'flags'

import { getActiveTab, setActiveTab } from 'ducks/editor/tabs'
import { getSelection, setSelection } from 'ducks/editor/selection'
import { getParentComponent } from 'ducks/editor/objects'
import { getDefaultDatasource } from 'ducks/apps/datasources'

import DataPanel from 'components/AppDetail/Data/Panel'
import { SettingsPanel } from 'components/AppDetail/Settings'
import { Panel } from 'components/Shared/Panel'

import AddPanel from 'components/Editor/AddObject/Panel'
import EditPanel from 'components/Editor/RightPanel'
import PublishPanel from 'components/Editor/Publish'
import BrandingPanel from 'components/Editor/Branding'
import ScreensPanel from 'components/Editor/Screens'
import AnalyticsPanel from 'components/Editor/Analytics'
import VersionsPanel from 'components/Editor/Versions'

import './LeftPanel.scss'

const LeftPanel = ({
  match,
  selection,
  activeTab,
  setActiveTab,
  datasource,
}) => {
  const { hasDesignVersioning } = useFlags()
  const path = window.location.pathname

  useEffect(() => {
    if (!activeTab) {
      if (
        path.includes('/screens') ||
        (datasource && datasource.type === 'api')
      ) {
        setActiveTab(null)
      }

      if (path.includes('/data')) {
        setActiveTab(DATA)
      }

      if (path.includes('/app-settings')) {
        setActiveTab(SETTINGS)
      }

      if (hasDesignVersioning && path.includes('/versions')) {
        setActiveTab(VERSIONS)
      }
    }
  }, [hasDesignVersioning])

  const renderSub = () => {
    if (selection.length > 0) return <EditPanel />

    switch (activeTab) {
      case ADD:
        return <AddPanel />
      case BRANDING:
        return <BrandingPanel />
      case DATA:
        return <DataPanel />
      case PUBLISH:
        return <PublishPanel />
      case SCREENS:
        return <ScreensPanel appId={match.params.appId} />
      case SETTINGS:
        return <SettingsPanel />
      case ANALYTICS:
        return <AnalyticsPanel appId={match.params.appId} />
      case VERSIONS:
        return <VersionsPanel appId={match.params.appId} />
      default:
        return null
    }
  }

  const children = renderSub()

  if (activeTab === ANALYTICS && selection.length === 0) {
    return (
      <>
        {}
        <Panel
          className={classNames('edit-bar-analytics', {
            'edit-bar-empty': children === null,
          })}
        >
          {children}
        </Panel>
      </>
    )
  }

  return (
    <>
      {}
      <Panel
        className={classNames('edit-bar', {
          'edit-bar-empty': children === null,
        })}
      >
        {children}
      </Panel>
    </>
  )
}

const mapStateToProps = (state, { match }) => {
  const { appId } = match.params
  const selection = getSelection(state)

  const parentComponent =
    selection.length === 1 ? getParentComponent(state, selection[0]) : null

  return {
    hasDoneEditing:
      parentComponent &&
      (parentComponent.type === GROUP || parentComponent.type === LIST),
    parentComponentId: parentComponent && parentComponent.id,
    activeTab: getActiveTab(state),
    selection,
    datasource: getDefaultDatasource(state, appId),
  }
}

const mapDispatchToProps = {
  setActiveTab,
  setSelection,
}

const connected = connect(mapStateToProps, mapDispatchToProps)(LeftPanel)

export default withRouter(connected)
